module.exports = __webpack_public_path__ + "static/media/ornamentalRule1.3936319d.png";